import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { getSingleRequest } from "store/actions";
import Loader from "components/shared/Loader";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { handleImage } from "helpers/functions";

const ShowRequest = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { formatMessage, locale } = useIntl();

  const { loading, error, singleRequest } = useSelector(
    (state) => state.requests
  );

  useEffect(() => {
    dispatch(getSingleRequest(id));
    // dispatch(getSection({ page: "contact", slug: id }));
  }, [dispatch, id]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  let contactMethod = singleRequest?.contactMethod,
    linkStartWith = contactMethod === "email" ? "mailto:" : "tel:",
    contactInfo =
      contactMethod === "email" ? singleRequest?.email : singleRequest?.phone;

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form single-request">
        <div className="card job-details">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"showRequest"} />
            </h4>
          </div>
          <div className="card-body table-details--">
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td style={{ width: "30%" }}>
                      <FormattedMessage id={"name"} />
                    </td>
                    <td>{singleRequest?.name} </td>
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id={"contactMethod"} />
                    </td>
                    <td>
                      <a
                        href={`${linkStartWith}${contactInfo}`}
                        target="_blank"
                        style={{
                          display: "block",
                          direction: "ltr",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        rel="noreferrer"
                      >
                        {contactInfo}
                      </a>
                    </td>
                  </tr>
                  {!!singleRequest?.personnel?.image && (
                    <tr>
                      <td>
                        <FormattedMessage id={"image"} />
                      </td>
                      <td>
                        <img
                          className="store-logo partner__"
                          src={handleImage(singleRequest?.personnel?.image)}
                          alt=""
                        />
                      </td>
                    </tr>
                  )}
                  {!!singleRequest?.personnel && (
                    <tr>
                      <td>
                        <FormattedMessage id={"name"} />
                      </td>
                      <td>
                        <Link to={`/personnel/${singleRequest?.personnel?.id}`}>
                          {singleRequest?.personnel?.name?.ar ||
                            singleRequest?.personnel?.name}
                        </Link>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <FormattedMessage id={"country"} />
                    </td>
                    <td>
                      {
                        (singleRequest?.personnel || singleRequest)?.country
                          ?.name?.[locale]
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id={"message"} />
                    </td>
                    <td style={{ whiteSpace: "pre-wrap" }}>
                      {singleRequest?.message}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowRequest;
